// src/components/AboutModal.js
import React from "react";
import version from "../version"; // ถ้ามี version

export default function AboutModal({ show, onClose }) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-xl p-6 shadow-xl max-w-sm w-full text-center">
        <div className="flex justify-center mb-2">
          <span className="text-4xl">⏳✨</span>
        </div>
        <h2 className="text-xl font-bold mb-2">About Spendora</h2>
        <p className="text-gray-700 mb-4">
          <b>Spendora</b> isn’t just a time tracker, it’s your daily companion to turn every hour into something bright and meaningful.
          <br /><br />
          <span className="block italic text-indigo-500">
            Start spending your time like it’s the most precious currency.<br/>
            Every day, every minute, every moment—make it sparkle.
          </span>
          <br /><br />
          <span className="text-xs text-gray-500">
            Built with <span className="inline-block">❤️</span> by <a href="mailto:thungong@thatwhy.me" className="underline hover:text-indigo-600">thungong@thatwhy.me</a>
          </span>
          <br />
          <span className="text-xs text-gray-400">v{version}</span>
        </p>
        <button
          onClick={onClose}
          className="mt-3 bg-indigo-500 text-white rounded px-4 py-2 font-semibold shadow hover:scale-105 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
}